import Youtube from "./youtube/index.vue";
import Vimeo from "./vimeo2.0/index.vue";
import DefaultPlayer from "./default/index.vue";
import R2Provider from "./r2/index.vue";
import { throttle } from "lodash";
import { chooseProvider } from "@/utils/videoSource";

export default {
    name: "video-providers",
    props: {
        videoInfo: Object,
        isHasPictureInPictureMode: {
            type: Boolean,
            default: true,
        },
        customMarginLeft: {
            type: Number,
            default: 0,
        },
    },
    components: { Youtube, Vimeo, DefaultPlayer, R2Provider },
    data() {
        return {
            isFixedVideo: false,
            isFirstStartVideo: false,
            player: null,
            positionPiP: { bottom: 30, left: 0 },
            hasShowVideoContinue: false,
            hasShowPreviewImg: true,
            loadedTimer: null,
        };
    },
    computed: {
        // R2 watch URL / course provider=r2 / signed R2 mp4 → new R2 provider;
        // anything else keeps the current byte-for-byte legacy (Vimeo/YouTube).
        provider() {
            return chooseProvider(this.videoInfo);
        },
        loadedTimerFormatted() {
            if (!this.loadedTimer) return "0:00";
            let min = Math.floor(this.loadedTimer / 60);
            let sec = this.loadedTimer % 60;
            return `${min}:${sec < 10 ? "0" : ""}${sec}`;
        },
    },
    mounted() {
        window.addEventListener("keydown", this.handleKeyEvents);
        if (window.innerWidth > 980 && this.isHasPictureInPictureMode) {
            this.initPiP();
            window.addEventListener("scroll", throttle(this.handleScroll, 15), true);
            window.addEventListener("resize", throttle(this.setPositionPiP, 15), true);
        }
        console.log("this.videoInfo", this.videoInfo);
        this.initVideo();
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.handleKeyEvents);
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.setPositionPiP);
    },
    methods: {
        initVideo() {
            let savedTime = localStorage.getItem(`_dmvideo_${this.videoInfo.id}`);
            if (savedTime && savedTime >= 5) {
                this.hasShowVideoContinue = true;
                this.loadedTimer = parseInt(savedTime, 10);
            }
        },
        onVideoStart(time = 0) {
            this.hasShowVideoContinue = false;
            this.$emit("video-start", time);
        },
        handleScroll() {
            this.isFixedVideo = window.scrollY > 100; // Simplified for readability
        },
        initPiP() {
            this.setPositionPiP();
        },
        setPositionPiP() {
            let sidebar = document.querySelector(".education-sidebar");
            if (sidebar) {
                this.positionPiP.left = sidebar.offsetLeft + 15 + this.customMarginLeft;
            }
        },
        isEditableFocused() {
            const el = document.activeElement;
            if (!el) return false;
            const tag = el.tagName;
            return tag === 'INPUT' || tag === 'TEXTAREA' || el.contentEditable === 'true';
        },
        handleKeyEvents(event) {
            if (this.isEditableFocused()) return;
            if (
                event.key === " " &&
                this.hasShowVideoContinue &&
                this.videoInfo.provider !== "youtube"
            ) {
                this.onVideoStart(this.loadedTimer);
            }
        },
    },
};
